import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import React from 'react'

export function initSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV ?? 'development',
    integrations: [
      new BrowserTracing(),
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

function ErrorFallback({ error }: { error: Error }) {
  return React.createElement(
    'div',
    { className: 'min-h-screen flex items-center justify-center bg-gray-50' },
    React.createElement(
      'div',
      { className: 'text-center p-8 max-w-md' },
      React.createElement('h1', { className: 'text-2xl font-bold text-red-600 mb-4' }, 'Something went wrong'),
      React.createElement('p', { className: 'text-gray-600 mb-4' }, error.message),
      React.createElement(
        'button',
        {
          onClick: () => window.location.reload(),
          className: 'bg-brand-600 text-white px-4 py-2 rounded hover:bg-brand-700',
        },
        'Reload page'
      )
    )
  )
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return React.createElement(
    Sentry.ErrorBoundary,
    { fallback: ({ error }) => React.createElement(ErrorFallback, { error: error as Error }) },
    children
  )
}
